module.exports = __webpack_public_path__ + "static/media/CAGlogo.48e22889.png";